// client/src/locales/en

const en = {
  translation: {
    404: {
      title: "Sorry, we can't find the page you're looking for",
      description: "It seems like the page doesn't exist or has been moved. You can always go back to our <0>homepage</0>.",
      link: '/'
    },
    cookiebar: {
      description: 'Our website stores cookies on your computer to provide you with more personalised services. Are you okay with this?',
      accept: 'Yes, I want the best experience!',
      decline: 'No, I\'m not',
      missing: 'Want to see this video? You can enable cookies by clicking <0>here</0>. You can change your privacy settings at any time at the bottom of this page.'
    },
    header: {
      contact: 'Contact',
      menu: 'Menu',
      close_menu: 'Close'
    },
    footer: {
      change_privacy_settings: 'Change privacy settings',
      about: {
        title: 'About BSL',
        text:
          'We bring together radiologists, developers, scientists and hospitals to build Veye Chest which automatically detects, classifies and tracks the growth of pulmanory nodules.',
        url: '/about-us',
        label: 'Get to know us'
      }
    },
    form: {
      step_button_text_next: "Next step",
      step_button_text_prev: "Previous step",
      make_a_choice: "Please select an option",
      multiple_answer_field_sample_text: "Multiple answer should be separated by semicolom, Example: Answer1; Answer2; Answer3;",
      form_submit: "Submit",
      form_checked: "Yes",
      form_not_checked: "No",
      dep_filled: "This field is mandatory",
      dep_email: "Enter an email",
      dep_phone: "Enter a phone number",
      notices: {
        success: {
          title: 'Your message has been sent.',
          text: 'We will be in touch very soon.'
        },
        connection_error: 'Could not connect to the server. Try again in a moment.',
        other_error: 'Something went wrong. Try again.'
      },
      labels: {
        name: 'Full name',
        mail: 'Email address',
        organization: 'Organisation',
        job_title: 'Job title',
        message: 'Tell us anything!',
        newsletter: 'Stay in touch with BSL through our monthly newsletter.',
        send: 'Send form',
        optional: 'Optional'
      }
    },
    events: {
      sources: {
        nursing: 'Nursing',
        zorgvisie: 'Zorgvisie',
        kinderopvangtotaal: 'Kinderopvangtotaal',
        zorgwelzijn: 'Zorg+Welzijn',
        ggzcongressen: 'GGZ Congressen',
        tandartspraktijk: 'TandartsPraktijk',
        huisarts: 'Huisartsgeneeskunde',
        skipr: 'Skipr',
      }
    },
    pagination: {
      older: "Older items",
      newer: "Newer items",
      earlier_events: "Earlies events",
      later_events: "Later events"
    },
    Tab1: {
      Title: "The Organization",
      Q1: "In which sector are you active? *",
      Q2: "Does your organization use a learning management system (LMS)? *",
      Q3: "How many people will use the e-learning solution? *"
    },
    Tab2: {
      Title: "Additional informations",
      Q1: "For whom do you want to use the e-learning modules? *",
      Q1_All_Job_Functions: "Select all jobs",
      Q2: "Which themes are important to your organization? *",
      Q2_All_Themes: "Select all themes",
      Q3: "What would be the ideal way of learning?",
      Q4: "How long do you want to use the e-learning modules? *"
    },
    Tab3: {
      Title: "Current situation",
      Q1: "Who is the current supplier of the e-learning modules? *",
      Q2: "Who is the current supplier of the learning management system (LMS)? *",
      Q3: "When will the contract with the current supplier expire? *"
    },
    Tab4: {
      Title: "Your advice",
      Name: "First name *",
      Prefix: "Prefix",
      Surname: "Surname *",
      Job_Function: "Job *",
      Organization: "Organization *",
      Phone: "Phone *",
      Email: "Email *",
    },
    Beslismatrix: {
      Intro_Text: "Our specialists are happy to help you find the learning resources that suit your organization. With this advice tool you get an idea of ​​interesting learning solutions with a high learning efficiency. Within 5 minutes you immediately have a non-binding advice.",
      Title: "Tailored advice",
      Success_Text: "Thank you for the submission.<br /><br /> Thank you for using our learning solutions advice tool. Our e-learning resources advisor will now get to work for you and will contact you with a tailor-made advice.<br /><br /> For more information you will be redirected to the information page...",
    }
  }
}

export default en
